import React, { useEffect, useRef, useState } from 'react';
import Header from "../../components/header/Header";
import FooterSection from "../../components/footer/FooterSection";
import NfdPlatformStartSection from "./sections/startSection/NfdPlatformStartSection";
import OrganizeYourselfSection from "./sections/organizeYourselfSection/OrganizeYourselfSection";
import MeetPersonalAssistantSection from "./sections/meetPersonalAssistantSection/MeetPersonalAssistantSection";
import LearnMoreInfoSection from "./sections/learnMoreInfoSection/LearnMoreInfoSection";
import FinalSection from "./sections/finalSection/FinalSection";
import ScrollTrigger from "gsap/ScrollTrigger";
import { gsap } from "gsap";
import { debounce } from "lodash";
import Category from "./sections/platformProjectsSection/components/Category";
import PlatformProjectsSection from "./sections/platformProjectsSection/PlatformProjectsSection";
import './sections/platformProjectsSection/platformProjectsSection.scss';

const NfdPlatform = () => {
	const [activeCategory, setActiveCategory] = useState(0);
	const [selectedIndex, setSelectedIndex] = useState(0);
	const [isCategoryFixed, setIsCategoryFixed] = useState(false);
	const [categoryInitialTop, setCategoryInitialTop] = useState(0);
	const [categoryInitialTopSelected, setCategoryInitialTopSelected] = useState(false);
	const [isScrolled, setIsScrolled] = useState(false);
	
	const headerRef = useRef<HTMLDivElement | null>(null);
	const categoryRef = useRef<HTMLDivElement | null>(null);
	const fixedBtnRef = useRef<HTMLDivElement | null>(null);
	
	const [width, setWidth] = useState(window.innerWidth);
	
	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}
	
	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => {
			window.removeEventListener("resize", updateDimensions);
		}
	}, []);
	
	useEffect(() => {
		const onResize = debounce(() => {
			ScrollTrigger.refresh();
		}, 500);
		
		window.addEventListener('load', onResize);
		onResize();
		
		return () => {
			window.removeEventListener('load', onResize);
		};
	}, []);
	
		useEffect(() => {
			const handleScroll = () => {
				if (headerRef.current && categoryRef.current) {
					const categoryTop = categoryRef.current.getBoundingClientRect().top;
					const headerHeight = headerRef.current.offsetHeight;
					const uniqueReviewsEl = document.querySelector(".uniqueReviewsComponent") as HTMLDivElement;
					const testCompEl = document.querySelector(".testSwipe") as HTMLDivElement;
					const learnMoreInfoEl = document.querySelector(".learnMoreInfo") as HTMLDivElement;
					const tempCategoryEl = document.querySelector(".tempCategoryHeight") as HTMLDivElement;
					
					if (categoryInitialTopSelected) {
						headerRef.current.style.transform = `translateY(-${108}px)`;
					}
					
					if (categoryTop <= headerHeight && !categoryInitialTopSelected) {
						setIsCategoryFixed(true);
						if (categoryTop > 0 && categoryTop <= 108) {
							headerRef.current.style.transform = `translateY(-${108 - categoryTop}px)`;
						}
						if (categoryTop <= 0) {
							if (width > 767) {
								categoryRef.current.style.position = 'fixed';
								categoryRef.current.style.top = '0';
								setCategoryInitialTop(window.scrollY);
								headerRef.current.style.transform = `translateY(-${108}px)`;
								setCategoryInitialTopSelected(true);
								
								if (tempCategoryEl) {
									tempCategoryEl.style.height = '87px';
								}
							}
							
							if (fixedBtnRef.current) {
								fixedBtnRef.current.style.opacity = '1';
							}
						}
					} else {
						
						if (width > 767) {
							if (window.scrollY <= categoryInitialTop) {
								setIsCategoryFixed(false);
								categoryRef.current.style.position = 'relative';
								categoryRef.current.style.top = 'unset';
								setCategoryInitialTop(0);
								setCategoryInitialTopSelected(false);
								
								if (tempCategoryEl) {
									tempCategoryEl.style.height = '0';
								}
							}
							
							if (categoryTop > 108) {
								headerRef.current.style.transform = `unset`;
							}
						} else {
							if (window.scrollY <= categoryInitialTop) {
								if (fixedBtnRef.current) {
									fixedBtnRef.current.style.opacity = '0';
								}
							}
						}
					}
					
					if (width > 767) {
						if (testCompEl) {
							const testCompBottom = testCompEl.getBoundingClientRect().bottom;
							const learnMoreInfoBottom = learnMoreInfoEl.getBoundingClientRect().bottom;
							
							if (testCompBottom <= headerHeight) {
								if (testCompBottom >= 0 && learnMoreInfoBottom < 0) {
									headerRef.current.style.transform = `translateY(-${testCompBottom}px)`;
									categoryRef.current.style.display = 'none';
								} else {
									headerRef.current.style.transform = `unset`;
								}
							} else {
								if (learnMoreInfoBottom < 0) {
									headerRef.current.style.transform = `translateY(-${108}px)`;
									
									categoryRef.current.style.display = 'flex';
								}
							}
						}
					}
				}
			};
			
			window.addEventListener("scroll", handleScroll);
			
			return () => {
				window.removeEventListener("scroll", handleScroll);
			};
		}, [categoryInitialTop]);
	
		
	const [ratio, setRatio] = useState(
		{
			value: document.documentElement.clientWidth / document.documentElement.clientHeight,
			isWide: document.documentElement.clientWidth / document.documentElement.clientHeight > 1,
			isTall: document.documentElement.clientWidth / document.documentElement.clientHeight <= 1
		}
	);
	
	const [isStuck, setIsStuck] = useState(false);
	
	const lastKnownScroll = useRef(0);
	
	useEffect(() => {
		const updateRatio = () => {
			setRatio(
				{
					value: document.documentElement.clientWidth / document.documentElement.clientHeight,
					isWide: document.documentElement.clientWidth / document.documentElement.clientHeight > 1,
					isTall: document.documentElement.clientWidth / document.documentElement.clientHeight <= 1
				}
			);
		};
		
		const handleWheel = () => {
			if (lastKnownScroll.current === window.scrollY) {
				setIsStuck(true);
				document.body.setAttribute(
					"style",
					"scroll-snap-type: none !important;"
				);
				document
				.getElementsByTagName("html")[0]
				.setAttribute("style", "scroll-snap-type: none !important;");
			} else if (isStuck) {
				setIsStuck(false);
				document.body.setAttribute(
					"style",
					"scroll-snap-type: y mandatory !important;"
				);
				document
				.getElementsByTagName("html")[0]
				.setAttribute("style", "scroll-snap-type: y mandatory !important;");
			}
			lastKnownScroll.current = window.scrollY;
		};
		
		window.addEventListener("resize", updateRatio);
		window.addEventListener("wheel", handleWheel);
		return () => {
			window.removeEventListener("resize", updateRatio);
			window.removeEventListener("wheel", handleWheel);
		};
	}, [ratio, isStuck]);
	
	const scrollToTop = () => {
		gsap.killTweensOf(window);
		if (headerRef && headerRef.current) {
			headerRef.current.style.transform = `translateY(0)`;
		}
		
		setIsScrolled(true);
		
		ScrollTrigger.getAll().forEach(trigger => trigger.kill());
		
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
		
		setTimeout(() => {
			setIsScrolled(false);
			ScrollTrigger.refresh();
		}, 5000);
	};
	
	return (
		<div className={`nfdPlatform ${isCategoryFixed ? "hidden" : "fixed"}`}>
			<Header mode={"dark"} ref={headerRef} />
			<NfdPlatformStartSection />
			<OrganizeYourselfSection />
			<MeetPersonalAssistantSection />
			<LearnMoreInfoSection
				width={width}
				activeCategory={activeCategory}
				setActiveCategory={setActiveCategory}
			/>
			<Category activeCategory={activeCategory} setActiveCategory={setActiveCategory} ref={categoryRef}/>
			<div className="tempCategoryHeight"/>
			<div className="nfdPlatform__fixed_btn" ref={fixedBtnRef}>
				<button
					onClick={scrollToTop}
				>
					<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
						<path d="M24.9454 19.6095C24.4247 20.1302 23.5805 20.1302 23.0598 19.6095L16.0026 12.5523L8.94541 19.6095C8.42471 20.1302 7.58049 20.1302 7.0598 19.6095C6.5391 19.0888 6.5391 18.2446 7.0598 17.7239L15.0598 9.72386C15.5805 9.20316 16.4247 9.20316 16.9454 9.72386L24.9454 17.7239C25.4661 18.2446 25.4661 19.0888 24.9454 19.6095Z" fill="white"/>
					</svg>
				</button>
			</div>
			<PlatformProjectsSection
				width={width}
				activeCategory={activeCategory}
				setActiveCategory={setActiveCategory}
				selectedIndex={selectedIndex}
				setSelectedIndex={setSelectedIndex}
				isScrolled={isScrolled}
			/>
			<FinalSection />
			<FooterSection />
		</div>
	);
};

export default NfdPlatform;